import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { NgSelectConfig } from '@ng-select/ng-select';

@Component({
  selector: 'app-search-bar-dropdown',
  templateUrl: './search-bar-dropdown.component.html',
  styleUrls: ['./search-bar-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None, 

})
export class SearchBarDropdownComponent implements OnInit,AfterViewInit {
  @Input() selectedId: any;
  @Input() name: string;
  @Input() id: string;
  @Input()  dataList:any[] = [];
  @Output() inputValueEmit:EventEmitter<number> = new EventEmitter();
  @Input() searchDropdown:boolean = false;
  @Input() newRecord:boolean = false;
  @Input() inputReqValidation:boolean = false;
  @Output() addNewRecord:EventEmitter<number> = new EventEmitter();
  @Input() selectLabel: string;
  @Input () optionDisable:any=null;

  isFocused:boolean = false;
  isSearchValue:boolean = false;
  serachvalue:string
  isDropdownActive: boolean = false; 
  constructor(private config: NgSelectConfig){
    this.config.notFoundText = 'Custom not found';
    // this.config.appendTo = 'body';
    // this.config.bindValue = 'value';
  }
  ngAfterViewInit(): void{
    const hiddenElement = document.getElementById('hidden');
  if (hiddenElement) {
    hiddenElement.focus();
  }
  }
ngOnInit(): void {
  if(this.optionDisable){
    this.dataList = this.dataList?.map(item => ({
      ...item,
      disabled: item.id === this.optionDisable
    }));
  }
}
clearSelection() {
  this.selectedId = null;
  this.isSearchValue = false;
  this.isDropdownActive = false;
  this.inputValueEmit.emit(this.selectedId)
}

customSearchFn(term: string, item) {
  item.name = item.name.replace(',','');
  term = term.toLocaleLowerCase();
  return item.name.toLocaleLowerCase().indexOf(term) > -1;
}
onSearchInput(searchTerm: any) {
  this.selectedId = null; 
  this.serachvalue = searchTerm.term
  this.isSearchValue = searchTerm.term?true :false
}
}
